<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.asId" filterable clearable @change="partserch"
                        placeholder="请选择" style="width: 180px;">
                        <el-option label="未核销" :value="0"></el-option>
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-input size="mini" v-model="formDatas.xxOrderNo" placeholder="总单编号" clearable
                        style="width: 180px; margin-left: 10px" @keyup.enter.native="partserch"></el-input>
                         <el-input size="mini" v-model="formDatas.xxCode" placeholder="券码" clearable
                        style="width: 180px; margin-left: 10px" @keyup.enter.native="partserch"></el-input>
                    <!--小象年月  date-->
                    <el-date-picker size="mini" v-model="formDatas.xxYearMonth" type="month" placeholder="选择小象年月"
                        format="yyyy-MM" value-format="yyyyMM" clearable style="margin-left: 10px;"
                        @change="partserch">
                    </el-date-picker>
                    <!-- 核销年月 -->
                    <el-date-picker size="mini" v-model="formDatas.acrYearMonthExchange" type="month"
                        placeholder="选择核销年月" format="yyyy-MM" value-format="yyyyMM" clearable
                        style="margin-left: 10px;" @change="partserch">
                    </el-date-picker>
                    <el-select size="mini" v-model="formDatas.acrxStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="待补充卡号" :value="1"></el-option>
                        <el-option label="待匹配" :value="2"></el-option>
                        <el-option label="已匹配" :value="3"></el-option>
                        <el-option label="匹配失败" :value="4"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.acrStatus" clearable @change="partserch" placeholder="请选择"
                        style="width: 160px">
                        <el-option label="已撤销" :value="0"></el-option>
                        <el-option label="创建" :value="1"></el-option>
                        <!-- <el-option label="第三方导入" :value="2"></el-option>
                        <el-option label="第三方领取" :value="3"></el-option>
                        <el-option label="已核销" :value="4"></el-option> -->
                        <el-option label="已核销" :value="5"></el-option>
                        <el-option label="退款" :value="6"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="warning" size="mini" style="margin-left: 10px;" @click="Out()">导出</el-button>
                    <el-button size="mini" type="primary" style="margin-left: 10px;"
                        @click="bulkImport = true">导入小象兑换劵记录
                    </el-button>
                    <el-button size="mini" type="primary" style="margin-left: 10px;"
                        @click="bulkImportTwo = true">导入关联劵码</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">


                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="acrxId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 批量导入 -->
            <el-dialog title="批量导入小象兑换劵记录(只显示处理失败的信息)" :visible.sync="bulkImport" width="70%"
                :before-close="bulkImportClose" style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://equityapp.aojuai.com/file/equityfee/excel/certificateRecordXiaoxiang1.xlsx', '小象兑换劵记录')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
            <el-dialog title="批量导入小象兑换劵记录关联劵码(只显示处理失败的信息)" :visible.sync="bulkImportTwo" width="70%"
                :before-close="bulkImportCloseTwo" style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulkTwo"
                        :auto-upload="false" ref="bulkTwo" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://equityapp.aojuai.com/file/equityfee/excel/certificateRecordXiaoxiang2.xlsx', '小象兑换劵记录关联劵码')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImportTwo" :table-data="bulkDataTwo" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkDataTwo.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
let Base64 = require('js-base64').Base64
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefShopReceiptTypeList, uploadAjefCertificateRecordXiaoxiangTwo, updateAjefShopBillDifferenceReceiptHandler, uploadAjefCertificateRecordXiaoxiangOne, getAjefShopListQuick, getAjefCertificateRecordXiaoxiangList, addAjefShopBillDifferenceReceipt, updateAjefShop, updateAjefShopReceiptStatusSend } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            bulkImportTwo: false,
            bulkDataTwo: [],
            bulkDataCopyTwo: [],
            columnsImportTwo: [{
                field: "",
                key: "a",
                title: "序号",
                width: 50,
                align: "center",
                fixed: 'left',
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return ++rowIndex;
                },
            },
            {
                field: "status",
                key: "status",
                title: "状态",
                width: 150,
                align: "center",
                fixed: 'left',

            },
            {
                field: "statusMsg",
                key: "statusMsg",
                title: "失败原因",
                width: 150,
                align: "center",
                fixed: 'left',

            },
            {
                field: "xxOrderNo",
                key: "xxOrderNo",
                title: "业务单号",
                width: 150,
                align: "center",
            },
            {
                field: "xxCode",
                key: "xxCode",
                title: "卡号",
                align: "center",
            },
            ],
            getAjefShopReceiptTypeList_data: [],
            getAjefShopReceiptTypeList_data2: [],
            columnsImport: [{
                field: "",
                key: "a",
                title: "序号",
                width: 50,
                align: "center",
                fixed: 'left',
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return ++rowIndex;
                },
            },
            {
                field: "status",
                key: "status",
                title: "状态",
                width: 150,
                align: "center",
                fixed: 'left',

            },
            {
                field: "statusMsg",
                key: "statusMsg",
                title: "失败原因",
                width: 150,
                align: "center",
                fixed: 'left',

            },
            {
                field: "xxOrderNo",
                key: "xxOrderNo",
                title: "订单编号",
                width: 150,
                align: "center",
            },
            {
                field: "xxMoneyFace",
                key: "xxMoneyFace",
                title: "订单金额",
                align: "center",
            },
            {
                field: "xxYearMonth",
                key: "xxYearMonth",
                title: "订单年月",
                align: "center",
            },
            ],
            getAjefShopList_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'acrxId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "xxOrderNo",
                    key: "xxOrderNo",
                    title: "订单编号",
                    align: "center",
                    fixed: 'left',
                    width: 190,
                },
                // {
                //     field: "xxMoneyFace",
                //     key: "xxMoneyFace",
                //     title: "平台订单金额(分)",
                //     align: "center",
                //     edit: false,
                //     width: 160,
                // },
                {
                    field: "xxMoneyFaceYuan",
                    key: "xxMoneyFaceYuan",
                    title: "平台订单金额(元)",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                // {
                //     field: "xxMoneySettlement",
                //     key: "xxMoneySettlement",
                //     title: "渠道商结算额(分)",
                //     align: "center",
                //     edit: false,
                //     width: 160,
                // },
                {
                    field: "xxMoneySettlementYuan",
                    key: "xxMoneySettlementYuan",
                    title: "渠道商结算额(元)",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "xxYearMonth",
                    key: "xxYearMonth",
                    title: "小象年月",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "xxCode",
                    key: "xxCode",
                    title: "卡号(第二张表匹配)",
                    align: "center",
                    edit: false,
                    width: 180,
                },


                {
                    field: "asName",
                    key: "asName",
                    title: "商户名称",
                    align: "center",
                    edit: false,
                    width: 180,
                },
                // {
                //     field: "acrExchangeShop",
                //     key: "acrExchangeShop",
                //     title: "商铺分账金额(分)",
                //     align: "center",
                //     edit: false,
                //     width: 160,
                // },
                {
                    field: "acrExchangeShopYuan",
                    key: "acrExchangeShopYuan",
                    title: "商铺分账金额(元)",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "acrYearMonthExchange",
                    key: "acrYearMonthExchange",
                    title: "核销年月",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                // {
                //     field: "createtime",
                //     key: "createtime",
                //     title: "创建时间",
                //     align: "center",
                //     edit: false,
                //     width: 160,
                // },
                {
                    field: "acrxStatus",
                    key: "acrxStatus",
                    title: "状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acrxStatus === 1 ? <el-tag size="mini" type="warning">待补充卡号</el-tag> :
                                        row.acrxStatus === 2 ? <el-tag size="mini" type="info">待匹配</el-tag> :
                                            row.acrxStatus === 3 ? <el-tag size="mini" type="success">已匹配</el-tag> :
                                                row.acrxStatus === 4 ? <el-tag size="mini" type="danger">匹配失败</el-tag> :
                                                    <el-tag size="mini" type="default">未知</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "acrxStatusDes",
                    key: "acrxStatusDes",
                    title: "状态描述",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acrStatus",
                    key: "acrStatus",
                    title: "券码状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acrStatus == 0 ? <el-tag size="mini" type="danger">已撤销</el-tag> :
                                        row.acrStatus == 1 ? <el-tag size="mini" type="warning">创建</el-tag> :
                                            row.acrStatus == 2 ? <el-tag size="mini" >第三方导入</el-tag> :
                                                row.acrStatus == 3 ? <el-tag size="mini" >第三方领取</el-tag> :
                                                    row.acrStatus == 4 ? <el-tag size="mini" type="success">已核销</el-tag> : row.acrStatus == 5 ? <el-tag size="mini" type="success">分账</el-tag> : <el-tag type="danger" size="mini">退款</el-tag>
                                }
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })

        this.getList();
    },
    mounted() { },
    methods: {
        changeType(e) {
            const map = new Map(this.getAjefShopList_data.map(item => [item.asId, item]));
            const item = map.get(e);
            console.log(item);
            this.form.asrtType = item.asrtType
            this.form.realtionIdOld = item.asrtId
            getAjefShopReceiptTypeList({ pageSize: 0, asrtType: item.asrtType }).then(res => {
                this.getAjefShopReceiptTypeList_data = res.data;
            });
        },

        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record-xiaoxiang/exportAjefCertificateRecordXiaoxiang',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '小象领取记录.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        getAjefShopListChange(val) {
            console.log(val);
            this.getAjefShopList_data.forEach((item, index) => {
                if (item.asId == val) {
                    this.form.asrDes = item.asrtReceiptTypeName
                }
            })

        },
        downloadFile(url, name) {
            //下载
            if (!url) {
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        Preview(url) {
            window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)));
        },
        handleCheck(row) {
            this.$prompt("请输入审核备注?", "确定要审核通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjefShopBillDifferenceReceiptHandler({ acrxId: row.acrxId, asbdrStatusDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleRefuseCheck(row) {
            this.$prompt("请输入审核备注?", "确定要拒绝通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    updateAjefShopBillDifferenceReceiptCancel({ acrxId: row.acrxId, asbdrStatusDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjefCertificateRecordXiaoxiangOne(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data;
                this.bulkDataCopy = res.data
            })
        },
        async updatabulkTwo(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjefCertificateRecordXiaoxiangTwo(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkDataTwo = res.data;
                this.bulkDataCopyTwo = res.data
            })
        },
        bulkImportCloseTwo(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkDataTwo = [];
                    this.bulkDataCopyTwo = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulkTwo.clearFiles();
                })
                .catch(_ => { });
        },

        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ acrxId: this.theRow.acrxId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShopReceiptStatusSend({ acrxIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopReceiptStatusSend({ acrxIds: row.acrxId }).then(res => {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        addAjefShopBillDifferenceReceipt(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShop(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.acrxId = row.acrxId
                    console.log(jsonObj);
                    updateAjefShop(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjefCertificateRecordXiaoxiangList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjefCertificateRecordXiaoxiangList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjefCertificateRecordXiaoxiangList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>